// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".catalog-container[data-v-5be2e781]{padding:10px;max-width:450px;margin:0 auto}", ""]);
// Exports
module.exports = exports;
